/**
 * V5FX early-access gating (UI only).
 *
 * V5FX is rolled out to a hand-picked set of users first. Everyone else sees
 * V5FX in the new-bot strategy selector as a disabled "Coming soon" option;
 * V4FX stays the current generation until V5FX ships to everyone.
 *
 * NOTE: this is a UI-only gate. The email list is bundled into the public
 * frontend, so it is visible to anyone who inspects the build and is trivially
 * bypassable — it is NOT a security boundary. The real enforcement points are
 * the worker dispatch register list and the Strapi `Strategy` record. If a hard
 * guarantee is needed, also gate V5FX bot creation server-side.
 *
 * Matching is case-insensitive; keep entries lowercase.
 */

/** Strapi `Strategy.name` of the generally-available current generation. */
export const CURRENT_GEN_STRATEGY = "V4FX";

/** Strapi `Strategy.name` of the early-access next generation. */
export const EARLY_ACCESS_STRATEGY = "V5FX";

/**
 * Emails granted early access to V5FX (lowercase only).
 *
 * Add operator/tester/customer emails here to expose V5FX as a selectable
 * strategy for those users. An empty list means everyone sees V5FX as
 * "Coming soon" (the pre-rollout default).
 */
export const V5FX_EARLY_ACCESS_EMAILS: readonly string[] = [
  "contact@abanchev.com",
  "senyconsulting@gmail.com",
  "chenchowine@gmail.com",
  "amengual.juan.mulet@gmail.com",
  "cvalbuena@outlook.com",
];

const allowSet = new Set(V5FX_EARLY_ACCESS_EMAILS.map((e) => e.trim().toLowerCase()));

/** True when the given email has V5FX early access. Case-insensitive; safe on null/undefined. */
export const isV5fxEarlyAccess = (email?: string | null): boolean =>
  !!email && allowSet.has(email.trim().toLowerCase());
